import { action, observable } from 'mobx'
import { Modal, message } from 'hljd'
import BaseStore from '@store/table'
import Api from '@api/shou_xie/setMeal'
import { isStoreAccount, isStoreHidden, getMerchantInfo } from '@util'
import { EDIT_CASE_PATH_A } from '@constant'
import Api1 from '@api/shou_xie/setMeal'

class Store extends BaseStore {
  constructor(tabKey) {
    super()
    this.key = tabKey
    this.getGrayCity()
  }
  $listApi = Api.listApi
  searchBar = null

  @observable property_id = getMerchantInfo().property_id
  @observable grayTestFlag = false
  @action
  getGrayCity() {
    const merchantId = getMerchantInfo().id
    Api1.getGrayCity({
      merchantId
    }).then(({ data: { weddingPlan } }) => {
      this.grayTestFlag = weddingPlan?.testCity == 1
      // console.log(this.grayTestFlag)
    })
  }

  @observable merchantInfo = {}
  @observable statusCount = {}
  @action
  updateMerchantInfo = data => {
    this.merchantInfo = data || {}
  }

  $getParams = () => {
    let { key } = this
    const params = {
      commodity_type: 1,
      property_id: isStoreAccount() ? this.currentProperty : null,
      sub_merchant_id: this.sub_merchant_id,
      is_one_button: 0,
      with_pending: 1,
      status: key == 3 ? 3 : 0
    }

    return {
      ...this.$params,
      ...params
    }
  }

  @observable key = '2'
  changeTab = key => {
    this.key = key
    this.$getList(1)
  }

  @action
  toEdit = record => () => {
    let msg = isStoreHidden()
    if (record.is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    if (msg == 'success') {
      window.open(
        `${EDIT_CASE_PATH_A}/${record.id}?propertyId=${record.property_id}`
      )
    } else {
      return message.error(msg)
    }
  }
  showModalFn = (id, sold, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    let msg = isStoreHidden()
    if (sold !== 'del' && msg != 'success') {
      message.error(msg)
      return false
    }
    let that = this
    Modal.confirm({
      content:
        sold == 'del'
          ? '确认要删除该案例吗'
          : sold == true
            ? '确认要上架吗'
            : '确认要下架吗',
      onOk() {
        if (sold == 'del') {
          that.deleteSetMealFn(id, flag)
        } else {
          that.soldOutFn(id, sold)
        }
      }
    })
  }

  showModalMove = (id, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可移除'
      })
    }
    Modal.confirm({
      content: '你是否确认移除该案例，该操作不可恢复',
      onOk: () => {
        this.deleteSetMealFn(id, flag)
      }
    })
  }

  //删除普通套餐
  async deleteSetMealFn(id, flag) {
    const { success } = await Api.deleteSetMeal({ id })
    if (success) {
      if (flag == 1) {
        this.$getList(1)
      } else {
        window.location.reload()
      }
    }
  }

  @action
  getStatusCount = async () => {
    const { data } = await Api.getStatusCount({ type: 2 })
    this.statusCount = data
  }
}
export default Store
